export const adjustFontSize = (size, isMobile, shiftPx = 2) => {
  if (!isMobile || !size) return size;

  if (typeof size === "number") {
    return `${Math.max(0, size - shiftPx)}px`;
  }

  if (typeof size === "string") {
    const trimmed = size.trim();
    if (!trimmed) return size;

    if (/^-?\d+(\.\d+)?$/.test(trimmed)) {
      return `${Math.max(0, Number(trimmed) - shiftPx)}px`;
    }

    return `calc(${trimmed} - ${shiftPx}px)`;
  }

  return size;
};
